import { render, staticRenderFns } from "./product-details.vue?vue&type=template&id=00081870&scoped=true&"
import script from "./product-details.vue?vue&type=script&lang=js&"
export * from "./product-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00081870",
  null
  
)

export default component.exports